"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var cssVars_1 = require("../../../helpers/cssVars");
var classnames_1 = __importDefault(require("classnames"));
var Label_1 = __importDefault(require("../../atoms/Label/Label"));
var ClinicDetail_dummy_1 = require("./ClinicDetail.dummy");
var ClinicDetail_styles_1 = __importDefault(require("./ClinicDetail.styles"));
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var loginState_1 = require("../../../types/loginState");
var useHideSidebar_1 = __importDefault(require("../../../hooks/useHideSidebar"));
var API_1 = require("../../../middleware/API");
var transformClinicDetail_1 = __importDefault(require("../../../middleware/transformClinicDetail"));
var Loading_1 = __importDefault(require("../../atoms/Loading/Loading"));
var ClinicDetail = function (_a) {
    var loggedIn = _a.loggedIn;
    var _b = react_1.useState(true), isLoading = _b[0], setIsLoading = _b[1];
    var _c = react_1.useState(ClinicDetail_dummy_1.schoolDummy), school = _c[0], setSchool = _c[1];
    var _d = react_1.useState(ClinicDetail_dummy_1.contactDummy), contact = _d[0], setContact = _d[1];
    var _e = react_1.useState(), clinic = _e[0], setClinic = _e[1];
    var id = react_router_dom_1.useParams().id;
    useHideSidebar_1.default();
    react_1.useEffect(function () {
        // get clinics from api, setClinics and set coaches
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var data, _a, school_1, contact_1, clinic_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, API_1.getClinicDetail(id)];
                    case 1:
                        data = _b.sent();
                        if (!(data instanceof Error)) {
                            _a = transformClinicDetail_1.default(data), school_1 = _a.school, contact_1 = _a.contact, clinic_1 = _a.clinic;
                            // setSchool(school); // To-do
                            // setContact(contact); // To-do
                            setClinic(clinic_1);
                        }
                        setIsLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getData();
    }, []);
    if (loggedIn !== loginState_1.LOGGEDIN) {
        return react_1.default.createElement(react_router_dom_1.Redirect, { to: "/login" });
    }
    if (isLoading) {
        return react_1.default.createElement(Loading_1.default, null);
    }
    return (react_1.default.createElement(ClinicDetail_styles_1.default, null,
        react_1.default.createElement("div", { className: "container" },
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "btn-wrapper" },
                    react_1.default.createElement(react_router_dom_1.Link, { to: "/agenda" },
                        react_1.default.createElement(Button_1.default, null,
                            react_1.default.createElement("svg", { className: "icon icon-arrow icon-left", "aria-hidden": "true" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#arrow-left" })),
                            react_1.default.createElement("span", null, "Terug")))),
                react_1.default.createElement("div", { className: "header" },
                    react_1.default.createElement("h1", { className: "title" }, "Clinic"),
                    react_1.default.createElement("p", { className: "description" }, "Hier vind je meer informatie over jouw geboekte clinic."))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "section sectionSplit" },
                    react_1.default.createElement("h2", { className: "sectionTitle" }, "School informatie"),
                    school && (react_1.default.createElement("div", { className: "sectionInner" },
                        react_1.default.createElement("b", null, school.name),
                        react_1.default.createElement("p", null,
                            school.street,
                            " ",
                            react_1.default.createElement("br", null),
                            school.postal_code,
                            " ",
                            school.city),
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("svg", { className: "icon icon--mail" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#mail" })),
                            " ",
                            school.email,
                            " ",
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("svg", { className: "icon icon--phone" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#phone" })),
                            " ",
                            school.phone)))),
                react_1.default.createElement("div", { className: "section sectionSplit" },
                    react_1.default.createElement("h2", { className: "sectionTitle" }, "Contact informatie"),
                    contact && (react_1.default.createElement("div", { className: "sectionInner" },
                        react_1.default.createElement("b", null, "Klas"),
                        react_1.default.createElement("p", null,
                            contact.group,
                            ", ",
                            contact.students,
                            " ",
                            react_1.default.createElement("br", null)),
                        react_1.default.createElement("b", null, "Contactpersoon"),
                        react_1.default.createElement("p", null, contact.name),
                        react_1.default.createElement("p", null,
                            react_1.default.createElement("svg", { className: "icon icon--mail" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#mail" })),
                            " ",
                            contact.email,
                            " ",
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("svg", { className: "icon icon--phone" },
                                react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#phone" })),
                            " ",
                            contact.phone))))),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "section" },
                    react_1.default.createElement("h2", { className: "sectionTitle" }, "School informatie"),
                    clinic && (react_1.default.createElement("div", { className: "sectionInner sectionInnerFlex" },
                        react_1.default.createElement("div", { className: "column" },
                            react_1.default.createElement("b", null, clinic === null || clinic === void 0 ? void 0 :
                                clinic.name,
                                ' ',
                                (clinic === null || clinic === void 0 ? void 0 : clinic.cancelled) && react_1.default.createElement(Label_1.default, { text: "Geannuleerd", color: cssVars_1.cssVars.colors.error })),
                            react_1.default.createElement(Label_1.default, { text: clinic.type })),
                        react_1.default.createElement("div", { className: "column" },
                            react_1.default.createElement("b", null, "Wanneer"),
                            react_1.default.createElement("div", { className: "split" },
                                react_1.default.createElement("p", null,
                                    react_1.default.createElement("svg", { className: "icon icon--calendar" },
                                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#calendar" })),
                                    react_1.default.createElement("span", { className: classnames_1.default(clinic.cancelled && 'cancelled') }, clinic.date),
                                    ' ',
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement("svg", { className: "icon icon--clock" },
                                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#clock" })),
                                    react_1.default.createElement("span", { className: classnames_1.default(clinic.cancelled && 'cancelled') }, clinic.time)),
                                react_1.default.createElement("p", null,
                                    react_1.default.createElement("svg", { className: "icon icon--location" },
                                        react_1.default.createElement("use", { xmlnsXlink: "http://www.w3.org/1999/xlink", xlinkHref: "/dist/svg/sprite.min.svg#location" })),
                                    " ",
                                    clinic.street,
                                    ", \u00A0",
                                    clinic.postal_code,
                                    " ",
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement("a", { href: "https://www.google.com/maps?daddr=" + clinic.street + "+" + clinic.postal_code, target: "_blank", className: "directions" }, "Routebeschrijving")))))))))));
};
exports.default = ClinicDetail;
